// Count receives the whole checkbox/facet state; send only selected options.
// Prices, metadata, option objects and malformed values retain their identity.
export function serializeCatalogFilters(filters) {
  if (!filters || typeof filters !== 'object' || Array.isArray(filters)) return filters;
  const result = {...filters};
  for (const key of ['colors', 'sizes', 'trends']) {
    if (Array.isArray(filters[key])) result[key] = filters[key].filter(item => item?.checked === true);
  }
  return result;
}
